import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionAdjustComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionAdjust"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <g clipPath="url(#clip0_3379_2253)">
        <path d="M3.99992 5.66504L6.33325 5.66504" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.66667 5.66504L10 5.66504" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 8.33179L7 8.33179" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.33333 8.33179L10 8.33179" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.33325 4.66504L6.33325 6.66504" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.33325 7.33179L8.33325 9.33179" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3379_2253">
          <rect width="8" height="8" fill="white" transform="translate(11 3) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransactionAdjust = withIcon(TransactionAdjustComponent);
